import React, {useState} from "react";
import axios from "axios";
import {createSetDataFreshAction} from "../../actions/dataActions";
import {useDispatch, useSelector} from "react-redux";
import {getDataFresh} from "../../state/selectors";
import { Button, Checkbox, Control, Field } from "@allxsmith/bestax-bulma";
import useEditableTableNumberCell from "../../hooks/useEditableTableNumberCell";
import useSafeSave from "../../hooks/useSafeSave";
import useEditableTableTextCell from "../../hooks/useEditableTableTextCell";
import useEditableTableCostCell from "../../hooks/useEditableTableCostCell";
import DeleteWarningModal from "../Modal/DeleteWarningModal";
import {AsyncTypeahead} from "react-bootstrap-typeahead";

export default function WorkLookupRow({workLookup, endpoint, updateValue, vehicleTypes}) {
  let dataFresh = useSelector(getDataFresh);
  const dispatch = useDispatch();

  const [editable, setEditable] = useState(false);
  const [, setTypeahead] = useState();
  const [isLoading, setLoading] = useState(false);
  const [searchData, setSearchData] = useState([]);
  const [lastEdited, setLastEdited] = useState();
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);


  const onSave = e => {
    const url = endpoint + "worklookup/update/" + workLookup.id;
    const conf = {
      method: "put",
      data: workLookup,
      url
    };
    setEditable(false);

    return axios(conf).then(() => {
      dispatch(createSetDataFreshAction(dataFresh + 1));
    });
  };


  const handleDelete = e => {
    const url = endpoint + "worklookup/update/" + workLookup.id;
    const conf = {
      method: "delete",
      url
    };
    setEditable(false);

    return axios(conf).then(() => {
      dispatch(createSetDataFreshAction(dataFresh + 1));
    });
  }

  const checkUpdated = () => {
    return axios
      .get(endpoint + "worklookup/update/" + workLookup.id)
      .then(
        checkWorkLookup =>
          (new Date(checkWorkLookup.data.last_saved).getTime() -
            new Date(workLookup.last_saved).getTime()) /
          1000 <
          1
      );
  };


  const [makeDirty, safeSave] = useSafeSave(
    onSave,
    lastEdited,
    undefined,
    checkUpdated
  );

  const onChange = e => {
    makeDirty();
    setLastEdited(new Date());
    let newWorkLookup = {...workLookup};
    newWorkLookup[e.target.name] = e.target.value;
    updateValue(newWorkLookup);
  };

  const onCheck = e => {
    const toUpdate = {
      target:{
        name: e.target.name,
        value: e.target.checked
      }
    };
    onChange(toUpdate);
  }

  const handleSearch = e => {
    setLoading(true);
    axios.get(`/api/contacts?contact_type=SP&search=${e}`).then(resp => {
      setSearchData(resp.data.results);
      setLoading(false);
    });
  }

  const handleWorkSupplierSelect = supplier => {
    let newWorkLookup = {...workLookup}
    newWorkLookup.supplier = supplier[0];
    updateValue(newWorkLookup);
  };


  const saveAfterButtonClick = () => {
    const url = endpoint + "worklookup/update/" + workLookup.id;
    const conf = {
      method: "put",
      data: workLookup,
      url
    };

    return axios(conf).then(() => {
      dispatch(createSetDataFreshAction(dataFresh + 1));
    });
  };

  const buttonClick = prop => {
    workLookup[prop] = !workLookup[prop];
    saveAfterButtonClick();
  };

  return (
    <tr key={workLookup.id}>
      {useEditableTableTextCell({
          propName: "description",
          value: workLookup.description,
          onChange: onChange,
          onSave: safeSave,
          editable,
          setEditable,
          inlineEdit: true
        }
      )}
      {useEditableTableNumberCell({
        propName: "labour_hours",
        value: workLookup.labour_hours,
        onChange: onChange,
        onSave: safeSave,
        editable,
        setEditable,
        inlineEdit: true
      })}
      {useEditableTableCostCell({
        propName: "labour_cost",
        value: workLookup.labour_cost,
        onChange: onChange,
        onSave: safeSave,
        editable,
        setEditable,
        inlineEdit: true
      })}
      {useEditableTableCostCell({
        propName: "customer_labour_cost",
        value: workLookup.customer_labour_cost,
        onChange: onChange,
        onSave: safeSave,
        editable,
        setEditable,
        inlineEdit: true
      })}
      <td>
        <Field className="has-addons">
          <Control>
            <AsyncTypeahead
              useCache={false}
              id="typeahead"
              labelKey="display_name"
              minLength={2}
              name={"supplier"}
              onSearch={handleSearch}
              onChange={handleWorkSupplierSelect}
              placeholder={"Search Supplier"}
              disabled={!editable}
              options={searchData}
              ref={typeahead => setTypeahead(typeahead)}
              className="typeahead"
              isLoading={isLoading}
              selected={workLookup.supplier && workLookup.supplier.id ? [workLookup.supplier] : []}
            />
          </Control>
          {editable ? (
            <Control>
              <Button
                className="small-row-white"
                color="success"
                onClick={onSave}
              >
                S
              </Button>
            </Control>
          ) : (
            <Control>
              <Button
                className="small-row-black"
                onClick={() => setEditable(!editable)}
              >
                E
              </Button>
            </Control>
          )}
        </Field>
      </td>
      <td>
        <Field className="has-addons">
          <Control>
            <Checkbox
              name={"default_item"}
              checked={workLookup.default_item}
              onChange={onCheck}
            />
          </Control>
          {editable ? (
            <Control>
              <Button
                className="small-row-white"
                color="success"
                onClick={onSave}
              >
                S
              </Button>
            </Control>
          ) : (
            <Control>
              <Button
                className="small-row-black"
                onClick={() => setEditable(!editable)}
              >
                E
              </Button>
            </Control>
          )}
        </Field>
      </td>
      <td>
        {workLookup.part_work_lookup ? workLookup.part_work_lookup.length : 0}
      </td>
      <td>
        <Button
          onClick={() => (window.open(`/detailWorkLookup/${workLookup.id}`, "_self"))}
          color={"success"}
        >
          View
        </Button>
      </td>
      <td className="float-right">
        <Button
          color="danger"
          data-testid={`submit-work-delete${workLookup.id}`}
          onClick={setDeleteModalOpen}
        >
          Delete
        </Button>
      </td>
      <DeleteWarningModal
        open={deleteModalOpen}
        setOpen={setDeleteModalOpen}
        onDelete={handleDelete}
      />
    </tr>
  );
}
